<template>
  <div>
    <div class="logo text-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1150.8 311.1"
        class="h-full w-40"
      >
        <path
          fill="#052e4a"
          d="M212.8,132.8c4.8,0,7.6.7,9.1,1.1v-24.4c-2.4-1.1-8.3-2.2-14.4-2.2-23.7,0-38.9,15.7-38.9,39.8v12.2h-17.8v24.8h17.8v82.2h29.1v-82.2h24.1v-24.8h-24.1v-11.7c0-12,8.5-14.8,15-14.8Z"
        />
        <path fill="#052e4a" d="M264.6,266.3V108.9h-28.9v157.5h28.9Z" />
        <path
          fill="#052e4a"
          d="M434,127.3h-26.1v15c0,9.6-5.2,17-16.5,17h-5.4v25.7h19.4v49.8c0,20.7,13.1,33.1,33.9,33.1s13.7-1.5,16.3-2.6v-23.9c-1.5.4-5.4.9-8.9.9-8.3,0-12.6-3-12.6-12.4v-44.8h21.5v-25.7h-21.5v-32Z"
        />
        <path
          fill="#052e4a"
          d="M490.3,200.6c.7-9.8,8.9-21.1,23.9-21.1s23.5,10.4,23.9,21.1h-47.9ZM540.9,228.5c-3.5,9.6-10.9,16.3-24.4,16.3s-26.3-10.2-27-24.4h76.6c0-.4.4-4.8.4-8.9,0-34.4-19.8-55.5-52.9-55.5s-52.6,22.2-52.6,56.3,25.9,57.2,55.2,57.2,43.3-15.4,48.7-33.9l-24.1-7.2Z"
        />
        <path
          fill="#052e4a"
          d="M723.2,200.6c.7-9.8,8.9-21.1,23.9-21.1s23.5,10.4,23.9,21.1h-47.9ZM773.9,228.5c-3.5,9.6-10.9,16.3-24.4,16.3s-26.3-10.2-27-24.4h76.6c0-.4.4-4.8.4-8.9,0-34.4-19.8-55.5-52.9-55.5s-52.6,22.2-52.6,56.3,25.9,57.2,55.2,57.2,43.3-15.4,48.7-33.9l-24.1-7.2Z"
        />
        <path
          fill="#052e4a"
          d="M802.5,236.5c1.3,12.2,12.4,33.1,44.6,33.1s41.5-17.8,41.5-35.2-10.7-28.5-31.8-32.8l-15.2-3.3c-5.9-1.1-9.8-4.4-9.8-9.6s6.1-10.7,13.7-10.7c12.2,0,16.7,8,17.6,14.4l24.1-5.4c-1.3-11.5-11.5-30.9-42-30.9s-40,15.9-40,35,9.4,27.4,30,32l14.1,3.3c8.3,1.7,11.5,5.7,11.5,10.4s-4.6,10.7-14.1,10.7-18.9-7.8-19.6-16.3l-24.8,5.4Z"
        />
        <path
          fill="#052e4a"
          d="M998.5,159.3h-37.8l-37,39.8v-90.3h-28.9v157.5h28.9v-28.3l12-12.6,28.3,40.9h35.5l-43.7-62,42.8-45Z"
        />
        <path
          fill="#052e4a"
          d="M687.9,108.9h-28.5v61.1c-3-5.7-11.7-13.3-30.2-13.3-30.2,0-51.3,24.6-51.3,55.9s21.8,56.3,52.2,56.3,25.2-6.5,30-15c0,5,.7,10.2,1.1,12.4h27.6c-.4-4.3-.9-12.2-.9-19.4V108.9ZM606.9,212.6c0-19.1,11.7-30,26.5-30s26.3,10.7,26.3,29.8-11.5,30.7-26.3,30.7-26.5-11.3-26.5-30.5Z"
        />
        <path
          fill="#052e4a"
          d="M352.3,159h30l-39.5,108.6c-5.6,15.6-13.2,26.9-22.6,33.9-9.3,7.1-20.8,10.3-34.7,9.6v-26c7.5.1,13.5-1.4,17.8-4.8,4.5-3.3,8-8.7,10.6-16.1l-44.5-105.1h30.6l28.2,72.9,24.1-72.9Z"
        />
        <path
          fill="#80bfe9"
          d="M1046.3,121.7L1150.8,1.5s-41,160.2-48.5,168.8c-7.3,8.4-44.1,5.8-49.8.8-5.7-5-6.1-49.5-6.1-49.5Z"
        />
        <path
          fill="#2272ba"
          d="M1031.8,108.6L1148.3,0s-158.6,46.6-167,54.4c-8.1,7.6-4.2,44.3.9,49.8,5.2,5.5,49.6,4.4,49.6,4.4Z"
        />
      </svg>
    </div>
    <div class="subtitle text-center">
      Connect to your flytedesk account to book a campaign with this supplier.
      Your account will allow you to track campaign progress, upload creatives,
      and view verifications.
    </div>
    <el-form
      ref="createAccountForm"
      label-position="top"
      label-width="100px"
      :model="createAccountForm"
      :rules="rules"
    >
      <div class="flex -m-3 margin-less">
        <el-form-item
          class="block p-3 flex-1"
          label="First Name"
          prop="buyer_first_name"
        >
          <el-input
            v-model="createAccountForm.buyer_first_name"
            name="first_name"
            placeholder="First Name"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="block p-3 flex-1"
          label="Last Name"
          prop="buyer_last_name"
        >
          <el-input
            v-model="createAccountForm.buyer_last_name"
            name="last_name"
            placeholder="Last Name"
          ></el-input>
        </el-form-item>
      </div>
      <el-form-item label="Email" prop="email">
        <el-input
          v-model="createAccountForm.email"
          v-mask.email
          name="email"
          placeholder="Email"
        ></el-input>
      </el-form-item>
      <el-form-item label="Password" prop="password">
        <el-input
          v-model="createAccountForm.password"
          type="password"
          placeholder="Password"
        ></el-input>
      </el-form-item>
      <el-form-item label="Confirm Password" prop="confirm_password">
        <el-input
          v-model="createAccountForm.confirm_password"
          type="password"
          placeholder="Password"
        ></el-input>
      </el-form-item>
      <br />
      <h4 class="text-center">Company Information</h4>
      <el-form-item label="Company Name" prop="buyer_company">
        <el-input
          v-model="createAccountForm.buyer_company"
          placeholder="Company Name"
        ></el-input>
      </el-form-item>
      <el-form-item label="Company Address" prop="primaryAddress.address">
        <el-input
          v-model="createAccountForm.primaryAddress.address"
          placeholder="Address"
        ></el-input>
      </el-form-item>
      <el-form-item label="City" prop="primaryAddress.city">
        <el-input
          v-model="createAccountForm.primaryAddress.city"
          placeholder="City"
        ></el-input>
      </el-form-item>
      <div class="flex -m-3 margin-less">
        <el-form-item
          class="block p-3 flex-1"
          label="Country"
          prop="primaryAddress.country"
        >
          <el-input
            v-model="createAccountForm.primaryAddress.country"
            placeholder="Country"
            @input="onCountryChange"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="block p-3 flex-1"
          :label="isUSA ? 'State' : 'Region'"
          prop="primaryAddress.state"
        >
          <select-state
            v-if="isUSA"
            v-model="createAccountForm.primaryAddress.state"
            placeholder="State"
          ></select-state>
          <el-input
            v-else
            v-model="createAccountForm.primaryAddress.state"
            placeholder="Region"
          ></el-input>
        </el-form-item>
      </div>
      <div class="flex -m-3 margin-less">
        <el-form-item
          class="block p-3 flex-1"
          label="Zip/Postal Code"
          prop="primaryAddress.zip_code"
        >
          <el-input
            v-model="createAccountForm.primaryAddress.zip_code"
            v-mask.zipcode
            placeholder="Zip/Postal Code"
          ></el-input>
        </el-form-item>
        <div class="block p-3 flex-1"></div>
      </div>
      <div class="flex -m-3" style="margin-top: -1.7em">
        <el-form-item
          class="block p-3 flex-1"
          label="Phone Number"
          prop="buyer_phone"
        >
          <el-input
            v-model="createAccountForm.buyer_phone"
            v-mask.phone
            placeholder="Phone Number"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="block p-3 flex-1"
          label="Business Type"
          prop="business_type"
        >
          <el-input
            v-model="createAccountForm.business_type"
            placeholder="Select business type"
          ></el-input>
        </el-form-item>
      </div>
      <div class="footer-info text-center">
        By clicking "Create Account" you agree to flytedesk's
        <a href="https://flytedesk.com/terms-and-conditions" target="_blank"
          >Terms & Conditions</a
        >
      </div>

      <el-alert
        v-if="formError"
        type="error"
        :title="formError"
        class="mt-4"
        :closable="false"
      />
      <login-mutation @data="onData" @error="formError = $event">
        <template v-slot="{ isSaving, createBuyerAccount }">
          <div class="mt-3 text-center">
            <el-button
              v-if="!isSaving"
              class="button-blue w-full"
              @click="createAccount(createBuyerAccount)"
            >
              Create Account
            </el-button>
            <loading-button v-else class="w-full" />
          </div>
        </template>
      </login-mutation>
    </el-form>

    <div class="subtitle text-center footer-info">
      Already have an account?
      <a @click="$emit('signInRequest')">Sign In</a>
    </div>
  </div>
</template>

<script>
import LoadingButton from '@/components/Core/Loading/LoadingButton';

import SelectState from '@/components/Core/SelectState.vue';
import { LoginMutation } from '@/components/Mutations';

export default {
  components: {
    LoadingButton,
    LoginMutation,
    SelectState
  },
  props: {
    supplierId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      createAccountForm: {
        email: '',
        password: '',
        confirm_password: '',
        buyer_company: '',
        primaryAddress: {
          address: '',
          address2: '',
          city: '',
          state: '',
          zip_code: '',
          country: 'USA'
        },
        buyer_first_name: '',
        buyer_last_name: '',
        supplier_id: this.supplierId,
        business_type: '',
        buyer_accept_terms: true
      },
      formError: null,
      rules: {
        email: [{ required: true, message: 'Email required', trigger: 'blur' }],
        password: [
          { required: true, message: 'Password required', trigger: 'blur' }
        ],
        buyer_company: [
          {
            required: true,
            message: 'Please input company name',
            trigger: 'blur'
          }
        ],
        buyer_first_name: [
          { required: true, message: 'First name required', trigger: 'blur' }
        ],
        buyer_last_name: [
          { required: true, message: 'Last name required', trigger: 'blur' }
        ],
        confirm_password: [
          {
            required: true,
            validator: this.validatePasswordConfirmation,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    isUSA() {
      const country = (
        this.createAccountForm.primaryAddress.country || ''
      ).toUpperCase();
      return (
        !country ||
        country === 'USA' ||
        country === 'US' ||
        country === 'UNITED STATES'
      );
    }
  },

  methods: {
    async onData() {
      this.$refs.createAccountForm.resetFields();

      await this.$store.dispatch('auth/getUser');

      if (this.$store.getters['auth/isAuthenticated']) {
        this.$emit('signedIn');
      } else {
        this.$message.error(
          'Failed to log in. Please try logging in using your credentials.'
        );
        this.$emit('signUpRequest');
      }
    },
    validatePasswordConfirmation(rule, value, callback) {
      if (value !== this.createAccountForm.password) {
        callback(new Error('Passwords do not match'));
      } else {
        callback();
      }
    },
    async createAccount(createBuyerAccount) {
      // Validation
      this.$refs.createAccountForm.validate(async valid => {
        if (valid) {
          await createBuyerAccount(this.createAccountForm);
        }
      });
    },
    onCountryChange() {
      if (!this.isUSA) {
        this.createAccountForm.primaryAddress.state = '';
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '~@/scss/_variables';

.subtitle {
  margin-bottom: 1.3em;
}

/deep/ .el-form-item__label {
  margin-bottom: -15px;
}

.footer-info {
  margin-top: 1em;
}

.margin-less {
  margin-bottom: -1em;
}

.flytedesk-logo {
  color: $color-blue;
  font-size: 2.7em;
  margin-bottom: 0.5em;
}
</style>
